<!--
  - Copyright (c) 2023. Haodong JU
  -->

<script>
import RevenueAnalysisPage from '@/views/AadenPages/billAndReport/analysis/RevenueAnalysisPage.vue'
import DefaultCostPage from '@/views/AadenPages/billAndReport/analysis/DefaultCostPage.vue'
import DishStatisticsPage from '@/views/AadenPages/billAndReport/analysis/report/DishStatistics.vue'
import OfflineModePage from '@/views/widget/commonLogic/OfflineModePage'
import { requireOfflineMode } from '@/model/global/GlobalSettings'

export default {
  name: 'AnalysisIndexPage',
  components: { DishStatisticsPage, DefaultCostPage, OfflineModePage, RevenueAnalysisPage },
  data () {
    return {
      offlineMode: requireOfflineMode(),
      tab: null
    }
  },
  computed: {
    dateRange () {
      return this.$parent.dateRange
    }
  }
}
</script>

<template>
  <div>
    <div class="mt-4">
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="black"
        style="background: transparent"
      >
        <v-tab>{{ $t('MaterialCostSettings') }}</v-tab>
        <v-tab>{{ $t('profitAnalysis') }}</v-tab>
        <v-tab>{{ $t('BusinessReport') }}</v-tab>
      </v-tabs>
      <v-divider />
    </div>
    <v-tabs-items
      v-model="tab"
      class="mt-4"
      style="background: transparent"
    >
      <template v-if="!offlineMode">
        <v-tab-item>
          <default-cost-page />
        </v-tab-item>
        <v-tab-item>
          <revenue-analysis-page :date-range="dateRange" />
        </v-tab-item>
        <v-tab-item>
          <dish-statistics-page />
        </v-tab-item>
      </template>
      <template v-else>
        <offline-mode-page />
      </template>
    </v-tabs-items>
  </div>
</template>

<style scoped>

</style>
